import { Create, RadioButtonGroupInput, SimpleForm, TextInput } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';
import { RichTextInput } from 'ra-input-rich-text';
import { categoryChoices } from './const';

const initialValues = {
  title: '',
};
export const PageCreate = (_props: unknown) => (
  <Create title={<CustomTitle />}>
    <SimpleForm redirect={false} defaultValues={initialValues}>
      <RadioButtonGroupInput source="category" choices={categoryChoices} />
      <TextInput source="title" />
      <RichTextInput source="body" />
    </SimpleForm>
  </Create>
);
